module.exports = __webpack_public_path__ + "static/media/macro1.7a6cabf5.png";